export default __webpack_public_path__ + "static/Facebook分享圖 1200x630-c1a027ba144d06e22748908304bef0ce.jpg";